// @TODO: <HEALTH2019>
(function () {
    App.directive('uploadList', uploadList);
    uploadList.$inject = ['Config'];
    function uploadList(Config) {
        return {
            restrict: 'E',
            scope: {
                list: '<',
                download: '&'
            },
            templateUrl: Config.TEMPLATES_DIR + 'Components/upload-list.html',
            controller: UploadListController,
            controllerAs: '$ctrl',
            bindToController: true
        }
    }

    UploadListController.$inject = [];
    function UploadListController() {
        var self = this;
        self.list = [];

        self.downloadFile = function(item) {
            self.download && self.download({$event: item});
        };

        self.$onChanges = function (changes) {
            console.log('[uploadList] changes', changes);
        };
    }
})();
// @TODO: </HEALTH2019>

